<template>
    <v-data-table class="pa-3" :headers="headers" :items="translatedItems" :loading="loading" disable-pagination disable-sort hide-default-footer />
</template>
<script>
import { mapActions } from 'vuex';
import translate from '../../../utils/translate.util';
export default {
    props: ['id'],
    data() {
        return {
            items: [],
            loading: true
        };
    },
    computed: {
        translatedItems() {
            return translate(this.items, 'full', this.$i18n.locale);
        },
        headers() {
            return [
                {
                    text: this.$t('Номер договора'),
                    value: 'contract_number'
                },
                {
                    text: this.$t('Наименование договора'),
                    value: 'contractor_name',
                    width: 180
                },
                {
                    text: this.$t('Адрес'),
                    value: 'address_full_name',
                    width: 180
                },
                {
                    text: this.$t('Отопление'),
                    value: 'heat'
                },
                {
                    text: this.$t('Горячая вода'),
                    value: 'hot_water'
                }
            ];
        }
    },
    methods: {
        ...mapActions('meters', ['getMeterContracts'])
    },
    async created() {
        this.items = await this.getMeterContracts(this.id);
        this.loading = false;
    }
};
</script>
